import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { cs } from 'date-fns/locale';

export default function RealTimeClock() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="text-center" data-testid="real-time-clock">
      <div className="text-5xl md:text-7xl font-extrabold tracking-tight text-[#052E16] font-['Manrope'] mb-2">
        {format(time, 'HH:mm:ss')}
      </div>
      <div className="text-lg md:text-xl text-[#F59E0B] font-semibold tracking-wide capitalize">
        {format(time, 'EEEE, d. MMMM yyyy', { locale: cs })}
      </div>
    </div>
  );
}
